/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Filter_BranchInputs */

const en_dashboard_filter_branch = /** @type {(inputs: Dashboard_Filter_BranchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter by branch`)
};

const pt_br2_dashboard_filter_branch = /** @type {(inputs: Dashboard_Filter_BranchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrar por filial`)
};

/**
* | output |
* | --- |
* | "Filter by branch" |
*
* @param {Dashboard_Filter_BranchInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dashboard_filter_branch = /** @type {((inputs?: Dashboard_Filter_BranchInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Filter_BranchInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_filter_branch(inputs)
	return pt_br2_dashboard_filter_branch(inputs)
});